import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { KTSVG } from '../../../../_metronic/helpers'
import DataRoomsCard from '../components/DataRoomCard'
import DataRoomTableRow from '../components/DataRoomTableRow'
import spaceStep from '../../../../_metronic/assets/images/images/data-room-step-img.png'
import { useIntl } from 'react-intl'
import { useAuth } from '../../auth'
import { ShareDrawer } from '../components/data-room-drawer/ShareDrawer'
import { CreateLinkDrawer } from '../components/data-room-drawer/CreateLinkDrawer'
import NoDataPage from '../../widgets/components/NoDataPage'
import { Filter } from '../../widgets/components/General/Filter'
import { useInvestorDatabase } from '../../investor-database/core/InvestorContext'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import useAllDataRooms from '../../../hooks/getAllDataRoomsById'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import moreOptionIcon from '../../../../_metronic/assets/images/svg/data-room/more-options-icon.svg'

interface DataRoomShareLink {
  id: number
  aclList: string
}

interface DataroomContent {
  dataroom_contentId: number
  isHidden: boolean
  isTrash: boolean
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  dataRoomId: number
  contentId: number
}

interface User {
  firstName: string
  lastName: string
  profileImage: number
  file: {
    fileId: number
    name: string
    isProtected: boolean
    module: string
    createdAt: string
    updatedAt: string
    deletedAt: string | null
    companyId: number | null
    userId: number
  }
}

interface DataRoomLogo {
  fileId: number
  name: string
  isProtected: boolean
  module: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  companyId: number | null
  userId: number
}

interface DataRooms {
  dataRoomId: number
  title: string
  subtitle: string
  status: string
  createdAt: string
  updatedAt: string
  companyId: number
  userId: number
  logoId: number
  bannerId: number
  data_Room_Share_Links: DataRoomShareLink[]
  contents: {
    contentId: number
    visits: any[]
    dataroom_content: DataroomContent
  }[]
  user: User
  dataRoomLogo: DataRoomLogo
  sharedWith: any[]
  contentCount: number
  visitsCount: number
}

function DataRoomsSpaces() {
  const { formatMessage } = useIntl()
  const { setDataRoomFilter } = useInvestorDatabase()
  const { companyId, role } = useAuth()
  const [dataRoomId, setdataRoomId] = useState<number | undefined>()
  const { getAllDataRoomsById } = useAllDataRooms()
  const {
    allRoomData,
    dataRoomStatus,
    setDataRoomStatus,
    dataRoomApiLoading,
    searchValue,
    setSearchValue,
  } = useMoveToFolderData()

  const handleSearchChange = (event: { target: { value: any } }) => {
    const { value } = event.target
    setSearchValue(value)
  }

  const [view, setView] = useState('grid')
  const handleClick = (type: React.SetStateAction<string>) => {
    setView(type)
  }

  useEffect(() => {
    getAllDataRoomsById()
  }, [companyId, searchValue, dataRoomStatus, role]) // eslint-disable-line react-hooks/exhaustive-deps

  const spaceSteps = [
    {
      id: 1,
      name: formatMessage({ id: 'Create a data room' }),
      text: formatMessage({ id: 'Organize your documents in a user-friendly landing page.' }),
    },
    {
      id: 2,
      name: formatMessage({ id: 'Upload documents' }),
      text: formatMessage({
        id: 'Effortlessly upload PDFs, Excel, text, videos, images, and more data',
      }),
    },
    {
      id: 3,
      name: formatMessage({ id: 'Create links' }),
      text: formatMessage({
        id: 'Password protected with email authentication for document access.',
      }),
    },
    {
      id: 4,
      name: formatMessage({ id: 'Track analytics' }),
      text: formatMessage({ id: 'Monitor metrics for all uploaded documents using analytics.' }),
    },
  ]

  return (
    <>
      <div className='data-rooms-spaces-wrapper pt-0 px-6'>
        <div className='Page_ToolBar-wrapper d-md-flex flex-row align-items-center justify-content-between'>
          <div className='Page_ToolBar-left'>
            <h4 className='mb-4'> {formatMessage({ id: 'Data Rooms' })}</h4>
            <p className='fw-semibold align-items-center d-flex font-size-12 text-primary'>
              <Link to='/' className='text-primary'>{formatMessage({ id: 'Home' })}</Link>
              <span className='h-1px bullet mx-2'></span>
              <span className='text-muted font-size-12'> {formatMessage({ id: 'Data Rooms' })}</span>
            </p>
            {/* <h5 className='mb-0'>{formatMessage({id: 'Data Rooms'})}</h5>
            <ul className='breadcrumb breadcrumb-line text-muted fs-6 fw-bold'>
              <li className='breadcrumb-item pe-3'>
                <Link to={`/`} className='pe-3 item_link'>
                  {formatMessage({id: 'Home'})}
                </Link>
              </li>
              <li className='breadcrumb-item pe-3 text-muted'>
                {formatMessage({id: 'Data Rooms'})}
              </li>
            </ul> */}
          </div>
          <div className='Page_ToolBar-right flex-row align-items-center justify-content-md-end justify-content-between'>
            <Link to={'/data-rooms/create-data-room'}>
              <button className='btn bg-primary w-100 font-size-13 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center custom-button-property'>
                {formatMessage({ id: 'Create Data Room' })}
              </button>
            </Link>
          </div>
        </div>
        <div className='spaces-toolbar-wrapper d-flex flex-md-row flex-column-reverse align-items-md-end justify-content-md-between dark-border'>
          <div className='all-data-rooms-head'>
            <p>{formatMessage({ id: 'All Data Rooms' })}</p>
          </div>
          <div className='all-data-rooms-tools'>
            <div className='list-grid-toggle bg-white'>
              <div
                className={`grid-view dark_bg_white ${view === 'grid' ? 'active' : ''}`}
                onClick={() => handleClick('grid')}
              >
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g clipPath='url(#clip0_4621_18294)'>
                    <path
                      d='M5 11C4.45 11 3.979 10.804 3.587 10.412C3.195 10.02 2.99934 9.54934 3 9V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H9C9.55 3 10.021 3.196 10.413 3.588C10.805 3.98 11.0007 4.45067 11 5V9C11 9.55 10.804 10.021 10.412 10.413C10.02 10.805 9.54934 11.0007 9 11H5ZM5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V15C3 14.45 3.196 13.979 3.588 13.587C3.98 13.195 4.45067 12.9993 5 13H9C9.55 13 10.021 13.196 10.413 13.588C10.805 13.98 11.0007 14.4507 11 15V19C11 19.55 10.804 20.021 10.412 20.413C10.02 20.805 9.54934 21.0007 9 21H5ZM15 11C14.45 11 13.979 10.804 13.587 10.412C13.195 10.02 12.9993 9.54934 13 9V5C13 4.45 13.196 3.979 13.588 3.587C13.98 3.195 14.4507 2.99934 15 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V9C21 9.55 20.804 10.021 20.412 10.413C20.02 10.805 19.5493 11.0007 19 11H15ZM15 21C14.45 21 13.979 20.804 13.587 20.412C13.195 20.02 12.9993 19.5493 13 19V15C13 14.45 13.196 13.979 13.588 13.587C13.98 13.195 14.4507 12.9993 15 13H19C19.55 13 20.021 13.196 20.413 13.588C20.805 13.98 21.0007 14.4507 21 15V19C21 19.55 20.804 20.021 20.412 20.413C20.02 20.805 19.5493 21.0007 19 21H15Z'
                      fill={view === 'grid' ? '#ffffff' : '#8898A6'}
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_4621_18294'>
                      <rect width='24' height='24' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div
                className={`list-view dark_bg_white  ${view === 'list' ? 'active' : ''}`}
                onClick={() => handleClick('list')}
              >
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g clip-path='url(#clip0_4588_18862)'>
                    <path
                      d='M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.5C3.17 16.5 2.5 17.18 2.5 18C2.5 18.82 3.18 19.5 4 19.5C4.82 19.5 5.5 18.82 5.5 18C5.5 17.18 4.83 16.5 4 16.5ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z'
                      fill={view === 'list' ? '#ffffff' : '#8898A6'}
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_4588_18862'>
                      <rect width='24' height='24' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div
              id='fc-toogle'
              title='Sort and Filter'
              data-bs-toggle='tooltip'
              data-bs-placement='left'
              data-bs-dismiss='click'
              data-bs-trigger='hover'
              className='all-data-rooms-filter d-flex flex-row align-items-center gap-1 bg-white'
              onClick={() => setDataRoomFilter(true)}
            >
              <KTSVG
                path={
                  dataRoomStatus
                    ? '/media/icons/duotune/general/gen031_selected.svg'
                    : '/media/icons/duotune/general/gen031.svg'
                }
                className='svg-icon-6 svg-icon-muted'
              />
              <span className='d-md-block d-none'>
                {dataRoomStatus ? formatMessage({ id: 'Filter*' }) : formatMessage({ id: 'Filter' })}
              </span>
            </div>
            <div className='all-data-rooms-searchBar d-flex align-content-center bg-white flex-grow-1 border border-none'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-3 position-absolute '
              />
              <input
                type='text'
                className='bg-body form-control form-control-flush font-size-13 font-weight-400'
                name='search'
                placeholder={formatMessage({ id: 'Search Data Room' })}
                data-kt-search-element='input'
                value={searchValue}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
        <Filter setDataRoomStatus={setDataRoomStatus} dataRoomStatus={dataRoomStatus} />

        {view === 'grid' && (
          <div className='mt-4'>
            <React.Fragment>
              {dataRoomApiLoading ? (
                <div className='data-rooms-space-grid'>
                  {Array(6)
                    .fill(0)
                    .map((_, index) => (
                      <div
                        className='DataRoom-Card-Wrapper bg-white'
                        style={{ width: '30%' }}
                        key={index}
                      >
                        <div className='DataRoom-Card-head d-flex align-items-center justify-content-between'>
                          <Skeleton
                            height={30}
                            width={150}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                          <div className='d-flex align-items-center'>
                            <div className='d-flex align-items-center'>
                              <Skeleton
                                width={40}
                                height={30}
                                style={{ marginRight: '10px' }}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />

                              <div className='card-option-wrapper'>
                                <button
                                  type='button'
                                  className='btn btn-sm card-option btn-icon btn-color-primary btn-active-light-primary'
                                >
                                  <img src={moreOptionIcon} alt=''></img>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='DataRoom-Card-body'>
                          <Skeleton
                            height={25}
                            width={200}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />

                          <div className='DataRoom-Card-body-grid'>
                            <div className='owner-wrapper'>
                              <Skeleton
                                height={40}
                                width={100}
                                style={{ marginTop: '10px' }}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>

                            <div className='owner-wrapper'>
                              <Skeleton
                                height={40}
                                width={100}
                                style={{ marginTop: '10px' }}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                          </div>
                          <div className='DataRoom-Card-body-grid'>
                            <div className=''>
                              <Skeleton
                                height={40}
                                width={100}
                                style={{ marginTop: '10px' }}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                            <div className=''>
                              <Skeleton
                                height={40}
                                width={100}
                                style={{ marginTop: '10px' }}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                          </div>
                        </div>
                        <div className='DataRoom-Card-bottom dark-border'>
                          <Skeleton
                            height={36}
                            style={{ width: '100%' }}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    ))}
                </div>
              ) : !dataRoomApiLoading && allRoomData?.modifiedDataRooms?.length === 0 ? (
                <NoDataPage width={'w-0'} />
              ) : (
                <div className='data-rooms-space-grid'>
                  {allRoomData?.modifiedDataRooms?.map((item: DataRooms, index: number) => (
                    <DataRoomsCard
                      key={index}
                      data={item}
                      getAllDataRoomsById={getAllDataRoomsById}
                      setdataRoomId={setdataRoomId}
                    />
                  ))}
                </div>
              )}
            </React.Fragment>

            <div className='space-create-steps-grid'>
              {!dataRoomApiLoading &&
                allRoomData?.modifiedDataRooms?.length === 0 &&
                spaceSteps.map((el) => (
                  <div className='space-create-steps-wrapper' key={el.id}>
                    <p className='step-no'>
                      {formatMessage({ id: 'Step' })} {el.id}
                    </p>
                    <img src={spaceStep} alt=''></img>
                    <h5 className='step-name'>{el.name}</h5>
                    <p className='mb-0'>{el.text}</p>
                  </div>
                ))}
            </div>
          </div>
        )}

        {view === 'list' && (
          <div className={`data-rooms-space-table `}>
            <div className='data-rooms-space-table-wrapper bg-white '>
              <table className='table  space-table'>
                <thead>
                  <tr className=' '>
                    <th>{formatMessage({ id: 'Name' })}</th>
                    <th>{formatMessage({ id: 'Last Modified' })}</th>
                    <th>{formatMessage({ id: 'Owner' })}</th>
                    <th>{formatMessage({ id: 'Shared with' })}</th>
                    <th>{formatMessage({ id: 'Documents' })}</th>
                    <th>{formatMessage({ id: 'Views' })}</th>
                    <th>{formatMessage({ id: 'Status' })}</th>
                    <th>{formatMessage({ id: 'Actions' })}</th>
                  </tr>
                </thead>
                <tbody>
                  {dataRoomApiLoading ? (
                    Array(5)
                      .fill(0)
                      .map((_, index) => (
                        <tr key={index}>
                          <td colSpan={8}>
                            <Skeleton
                              height={30}
                              style={{ width: '100%' }}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </td>
                        </tr>
                      ))
                  ) : !dataRoomApiLoading && allRoomData?.modifiedDataRooms?.length === 0 ? (
                    <tr>
                      <td colSpan={8}>
                        <div
                          className={`d-flex align-items-center justify-content-center flex-column text-center `}
                          style={{
                            marginTop: '10%',
                          }}
                        >
                          <div style={{ order: 1 }}>
                            <img
                              src={toAbsoluteUrl('/media/icons/investor-updates/NoDataImg.svg')}
                              alt='no-data-img'
                              height={200}
                              width={200}
                            />
                          </div>
                          <div className='w-100' style={{ order: 2 }}>
                            <div>
                              <h1>{formatMessage({ id: 'Nothing to show' })}</h1>

                              <p className='w-100 px-10'>
                                {formatMessage({
                                  id: "Currently we don't have anything to show here",
                                })}
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    allRoomData?.modifiedDataRooms?.map((item: DataRooms) => (
                      <DataRoomTableRow
                        data={item}
                        getAllDataRoomsById={getAllDataRoomsById}
                        setdataRoomId={setdataRoomId}
                      />
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <ShareDrawer dataRoomId={dataRoomId} />
        <CreateLinkDrawer dataRoomId={dataRoomId} />
      </div>
    </>
  )
}

export default DataRoomsSpaces
